export default __webpack_public_path__ + "static/media/skincodelogo.8e339ba7.gif";